/**
 * Add this to entities that shouldn't be highlighted by HighlightAddedComponentSystem
 */
class IgnoreHighlightComponent {
    constructor() {
        this.typeId = IgnoreHighlightComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
IgnoreHighlightComponent.id = 2021;
export default IgnoreHighlightComponent;
//# sourceMappingURL=IgnoreHighlightComponent.js.map